import httpRequest from "./httpRequest";

export const getSearchProducts = async (companyId, query) => {
    return await httpRequest.get(`/integrations/stripe/products/search`, {
        params: {
            query: query,
            expand: ['data.default_price']
        },
         headers: {'Pai-Company': companyId}
    });
}

export const retrieveProduct = async (companyId, productId) => {
    return await httpRequest.get(`/integrations/stripe/products/${productId}`, {
        params: {
            expand: ['default_price']
        },
         headers: {'Pai-Company': companyId}
    });
}

export const createSession = async (companyId, sessionData) => {
    return await httpRequest.post('integrations/stripe/checkout-sessions', sessionData, {
        headers: {'Pai-Company': companyId}
    })
}

export const retrieveCheckoutSession = async (companyId, checkoutSessionId) => {
    return await httpRequest.get(`integrations/stripe/checkout-sessions/${checkoutSessionId}`, {
        headers: {'Pai-Company': companyId}
    })
}

export const getRetrievePrices = async (companyId, productId) => {
    return await httpRequest.get(`/integrations/stripe/prices/${productId}`, {
        expand: ['data.default_price'],
        headers: {'Pai-Company': companyId}
    });
}

export const listSubscriptions = async (companyId, customerId) => {
    return await httpRequest.get(`/integrations/stripe/subscriptions`,{
        params: {
            customer: customerId
        },
        headers: {'Pai-Company': companyId}
    });
}

export const createCustomer = async (companyId, customerData) => {
    return await httpRequest.post(`/integrations/stripe/customers`, customerData, {
        headers: {'Pai-Company': companyId}
    });
}

export const searchCustomer = async (companyId, query) => {
    return await httpRequest.get(`/integrations/stripe/customers/search`, {
        params: {
            query: query
        },
        headers: {'Pai-Company': companyId}
    });
}

export const storeSubscription = async (companyId, subscriptionData) => {
    return await httpRequest.post(`/integrations/stripe/subscriptions`, subscriptionData, {
        headers: { 'Pai-Company': companyId }
    })
}

export const retrieveSubscription = async (companyId, subscriptionId, params) => {
    return await httpRequest.get(`/integrations/stripe/subscriptions/${subscriptionId}`, {
        params: params,
        headers: {'Pai-Company': companyId}
    })
}

export const listPromotionCode = async (companyId, params) => {
    return await httpRequest.get(`/integrations/stripe/promotion-codes`,{
        params: params,
        headers: {'Pai-Company': companyId}
    })
}

export const updateSubscription = async (companyId, subscriptionId, subscriptionData) => {
    return await httpRequest.put(`/integrations/stripe/subscriptions/${subscriptionId}`, subscriptionData, {
        headers: {'Pai-Company': companyId}
    })
}

export const verifyPromotionCode = async (companyId, promotionCode, params) =>{
    return await httpRequest.get(`/integrations/stripe/promotion-codes/${promotionCode}/verify`,{
        params: params,
        headers: {'Pai-Company': companyId}
    })
}

export const createSubscriptionSchedule = async (companyId, subscriptionScheduleData) => {
    return await httpRequest.post(`/integrations/stripe/subscription-schedules`, subscriptionScheduleData, {
        headers: {'Pai-Company': companyId}
    })
}

export const updateSubscriptionSchedule = async (companyId, subscriptionScheduleId, subscriptionScheduleData) => {
    return await httpRequest.put(`/integrations/stripe/subscription-schedules/${subscriptionScheduleId}`, subscriptionScheduleData, {
        headers: {'Pai-Company': companyId}
    })
}

export const cancelSubscriptionSchedule = async (companyId, subscriptionScheduleId, subscriptionScheduleData) => {
    return await httpRequest.post(`/integrations/stripe/subscription-schedules/${subscriptionScheduleId}/cancel`, subscriptionScheduleData, {
        headers: {'Pai-Company': companyId}
    })
}

export const releaseSubscriptionSchedule = async (companyId, subscriptionScheduleId, subscriptionScheduleData) => {
    return await httpRequest.post(`/integrations/stripe/subscription-schedules/${subscriptionScheduleId}/release`, subscriptionScheduleData, {
        headers: {'Pai-Company': companyId}
    })
}

export const searchInvoice = async (companyId, query, expandOptions) => {
    return await httpRequest.get(`/integrations/stripe/invoices/search`, {
        params: {
            query: query,
            expand: expandOptions,
        },
        headers: {'Pai-Company': companyId}
    });
}

export const createInvoice = async (companyId, invoiceData ) => {
    return await httpRequest.post(`/integrations/stripe/invoices`, { ...invoiceData }, {
        headers: {'Pai-Company': companyId}
    });
}

export const createInvoiceItem = async (companyId, invoiceData) => {
    return await httpRequest.post(`/integrations/stripe/invoices-items`, invoiceData, {
        headers: {'Pai-Company': companyId}
    });
}

export const finalizeInvoice = async (companyId, invoice) => {
    return await httpRequest.post(`/integrations/stripe/invoices/${invoice}/finalize`,null, {
        headers: {'Pai-Company': companyId}
    });
}

export const sendInvoice = async (companyId, invoice) => {
    return await httpRequest.post(`/integrations/stripe/invoices/${invoice}/send`,null, {
        headers: {'Pai-Company': companyId}
    });
}

export const setVoidInvoice = async (companyId, invoice) => {
    return await httpRequest.post(`/integrations/stripe/invoices/${invoice}/void`,null, {
        headers: {'Pai-Company': companyId}
    });
}

// EXTERNALS

export const getInvoice = async (companyId, uuidInvoice, params) => {
    return await httpRequest.get(`/integrations/ecommerce/orders/with-stripe-product/${uuidInvoice}`, {
        params: params,
        headers: {'Pai-Company': companyId}
    })
}

export const getInvoiceEcommerce = async (companyId, idInvoice, params) => {
    return await httpRequest.get(`/integrations/ecommerce/orders/${idInvoice}`, {
        params: params,
        headers: {'Pai-Company': companyId}
    })
}
